import { api } from '../../client';

export interface PlanningItemDto {
  id: string;
  project_id: string;
  name: string;
  duration_days: number;
  budget_amount: number;
  parent_id: string | null;
  notes: string | null;
  sort_order: number;
}

export const projectsPlanningApi = {
  async list(projectId: string): Promise<{ data?: PlanningItemDto[]; message?: string }> {
    return api.get(`/projects/planning?project_id=${encodeURIComponent(projectId)}`) as Promise<{
      data: PlanningItemDto[];
    }>;
  },

  async get(projectId: string, id: string): Promise<{ data?: PlanningItemDto; message?: string }> {
    return api.get(`/projects/planning/${id}`) as Promise<{ data: PlanningItemDto }>;
  },

  async create(
    projectId: string,
    data: {
      name: string;
      duration_days?: number;
      budget_amount?: number;
      parent_id?: string | null;
      notes?: string | null;
      sort_order?: number;
    }
  ): Promise<{ data?: PlanningItemDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/projects/planning', { project_id: projectId, ...data }) as Promise<{
      data: PlanningItemDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    _projectId: string,
    id: string,
    data: {
      name?: string;
      duration_days?: number;
      budget_amount?: number;
      parent_id?: string | null;
      notes?: string | null;
      sort_order?: number;
    }
  ): Promise<{ data?: PlanningItemDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/projects/planning/${id}`, data) as Promise<{
      data: PlanningItemDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(_projectId: string, id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/projects/planning/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
